import { useState } from 'react';
import { jsonFieldLabel } from '../../lib/reportFormat';

export function JsonField({ title, value }: { title: string; value: unknown }) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const text = jsonFieldLabel(value);
  const initialHeight = Math.min(280, Math.max(96, text.split('\n').length * 18 + 32));

  async function copy() {
    await navigator.clipboard.writeText(text);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1200);
  }

  return (
    <section className="card card-padding">
      <div className="flex items-center justify-between gap-3">
        <div className="rubric">{title}</div>
        <div className="flex items-center gap-2">
          <button type="button" className="btn-subtle btn-sm" onClick={() => setOpen((v) => !v)}>
            {open ? 'Свернуть' : 'Развернуть'}
          </button>
          <button type="button" className="btn-subtle btn-sm" onClick={() => void copy()}>
            {copied ? 'Скопировано' : 'Копировать'}
          </button>
        </div>
      </div>
      {open ? (
        <pre
          className="mono mt-3 min-h-24 max-h-[60vh] resize-y overflow-auto rounded-md bg-surface-2 p-3 text-caption text-text-secondary"
          style={{ height: `${initialHeight}px` }}
        >
          {text}
        </pre>
      ) : null}
    </section>
  );
}
